import React, {
    useState,
    useEffect
} from 'react'

import { ModalCloseIcon } from '../../assets/svg/icons'
import { handleHideModal } from '../../assets/js/custome'

import { LoadingView, ProfilePicLoader } from '../../components/common';
import { ApiErrorMessage } from '../../components/error/alertMessages';

import { handleAddBlisterPackNote, handleDeleteBlisterPackNote } from '../../services/actions/pharmacy/blisters/addBlisterPackData';
import { useDispatch } from 'react-redux';
import { useBlisterSelectors } from '../../services/selectors/blisterSelectors';
import { showToast } from '../../utils/helper/helper';

import Axios from '../../networking/intraceptor';

export const UpdatedBlisterPackonShelfLogslist = ({ setShowModal, showModal, patientProfileData }) => {

    const [tableData, setTableData] = useState({ loading: false, data: null, error: null })

    const fetchUpdatedLogsList = async () => {
        setTableData({ data: null, loading: true, error: null })

        try {
            const reqData = {
                blister_pack_id: patientProfileData.id
            }
            const response = await Axios.post('pharmacy-blisterPack-log', reqData);
            setTableData({ data: response?.data?.data?.data, loading: false, error: null })
            return { data: response.data, loading: false, error: null };
        } catch (error) {
            setTableData({ data: null, loading: false, error: error.message })
            return { data: '', loading: false, error: error.message };
        }
    };

    useEffect(() => {
        if (patientProfileData?.id) {
            fetchUpdatedLogsList()
        }
    }, [patientProfileData?.id])

    return (
        <React.Fragment>
            <div className="fixed top-0 left-0 right-0 z-50 bottom-0 flex items-center justify-center p-6 overflow-x-hidden overflow-y-auto bg-black bg-opacity-50 dark:bg-opacity-100">
                <div className="relative p-4 w-full max-w-5xl max-h-full" >
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                {patientProfileData?.name}
                            </h3>
                            <button type="button" onClick={() => handleHideModal(setShowModal, showModal, 'updated_logs')}
                                className="text-gray-400 close_btn hover:bg-gray-200 hover:text-gray-900 rounded-full 
								text-sm w-6 h-6 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                                <ModalCloseIcon />
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>

                        <div className="p-4 md:p-5 space-y-4">

                            {tableData?.loading ?
                                <div className="flex justify-center items-center mt-60 mb-80">
                                    <LoadingView />
                                </div> :
                                tableData?.error !== null ?
                                    <ApiErrorMessage /> :
                                    tableData?.data?.length === 0 ?
                                        <div className="bg-white rounded-md ">
                                            <p className="text-gray-500">No Record available</p>
                                        </div>
                                        :
                                        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
                                            <div className=" rounded relative overflow-auto scroll-box" style={{ maxHeight: '600px' }}>

                                                {/* <table className="bl_oatLogHistory w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 table-auto" >
                                                    <thead className="text-xs text-gray-900 uppercase blueBg-color dark:bg-gray-700 dark:text-gray-400"
                                                        style={{ borderBottom: '1px solid lightgray', background: '#f6f4f4' }}>
                                                        <tr>
                                                            <th className="px-4 py-2 text-left text-sm font-semibold border-r">LAST UPDATED</th>
                                                            <th className="px-4 py-2 text-left text-sm font-semibold border-r">UPDATED BY</th>
                                                            <th className="px-4 py-2 text-left text-sm font-semibold border-r">VERIFIED BY</th>
                                                            <th className="px-4 py-2 text-left text-sm font-semibold border-r">CHANGES</th>
                                                            <th className="px-4 py-2 text-left text-sm font-semibold border-r">TYPE</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {tableData?.data?.length > 0 &&
                                                            tableData?.data?.map((value, index) => (
                                                                <React.Fragment key={index}>
                                                                    {value.updated_col_name !== 'note' && value?.updated_col_name && 
                                                                        <tr className="border-b hover:bg-gray-50 ">
                                                                            <td className="px-4 py-3 text-sm text-gray-800 font-medium border-r">
                                                                                {value.last_updated_at}
                                                                            </td>
                                                                            <td className="px-4 py-3 text-sm text-gray-800 border-r">
                                                                                {value.updated_by}
                                                                            </td>
                                                                            <td className="px-4 py-3 text-sm text-gray-800 border-r">
                                                                                {value.verfication_by}
                                                                            </td>
                                                                            <td className="px-4 py-3 text-sm border-r ">
                                                                                {value.updated_col_name === 'blister_route' ?
                                                                                    <p className='font-bold uppercase'>Route</p> :
                                                                                    value.updated_col_name === 'facility' ?
                                                                                        <p className='font-bold uppercase'>Facility</p> :
                                                                                        value.updated_col_name === 'no_of_blister_pack' ?
                                                                                            <p className='font-bold uppercase'>NUMBER OF BLISTER PACK</p> : null
                                                                                }
                                                                                <div className="flex flex-col">
                                                                                    <div className="flex items-center gap-2">
                                                                                        <span className="px-2 py-1 bg-green-100 text-green-600 rounded-full text-xs font-semibold">
                                                                                            New Value
                                                                                        </span>
                                                                                        <span className="text-gray-800 font-medium">
                                                                                            {value?.updated_value}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="flex items-center gap-2 mt-1">
                                                                                        <span className="px-2 py-1 bg-red-100 text-red-600 rounded-full text-xs font-semibold">
                                                                                            Prev Value
                                                                                        </span>
                                                                                        <span className="text-gray-800">
                                                                                            {value?.previous_value}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </td>

                                                                            <td className="px-4 py-3 text-sm text-gray-800 border-r">
                                                                                {value.type === 'bulk' ?
                                                                                    <span className="text-gray-800">
                                                                                        Bulk
                                                                                    </span>
                                                                                    :
                                                                                    <span className="text-gray-800">
                                                                                        Single
                                                                                    </span>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                         } 
                                                                </React.Fragment>
                                                            ))}
                                                    </tbody>

                                                </table> */}

                                                {tableData?.data?.length > 0 &&
                                                    tableData?.data?.map((value, index) => (
                                                        <React.Fragment key={index}>
                                                            {value.updated_col_name !== 'note' && value?.updated_col_name && value.updated_value &&
                                                                <div className="bg-gray-50 border border-gray-200 rounded-lg shadow-sm p-2 mb-2">
                                                                    <div className="flex justify-between items-center mb-1 px-2">
                                                                        <div className="text-sm text-gray-500">
                                                                            {
                                                                                value.last_updated_at && value.updated_by &&
                                                                                <span className='text-left text-gray-500 italic fs-12'>
                                                                                    Updated by <span className='font-bold'>{value.updated_by}</span>,{value.verfication_by && <> verified by <span className='font-bold'>{value.verfication_by}</span> </>} on {value.last_updated_at}
                                                                                </span>
                                                                            }
                                                                            <span className="bg-blue-100 text-blue-600 text-xs font-semibold px-2 py-1 rounded-full ml-2">
                                                                                {value.type === "bulk" ? "Bulk" : "Single"}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="bg-white py-1 px-2 rounded-md flex justify-between">
                                                                        <p className="text-gray-700 font-semibold uppercase mb-2">
                                                                            {value.updated_col_name === "blister_route"
                                                                                ? "Route"
                                                                                : value.updated_col_name === "facility"
                                                                                    ? "Facility"
                                                                                    : value.updated_col_name === "no_of_blister_pack"
                                                                                        ? "Number of Blister Pack"
                                                                                        : ""}
                                                                        </p>
                                                                        <div className="flex gap-2">
                                                                            <div className="flex items-center gap-2">
                                                                                <span className="px-2 py-1 bg-green-100 text-green-600 rounded text-xs font-semibold">
                                                                                    New: {value.updated_value}
                                                                                </span>
                                                                            </div>
                                                                            <div className="flex items-center gap-2">
                                                                                <span className="px-2 py-1 bg-red-100 text-red-600 rounded text-xs font-semibold">
                                                                                    Prev: {value.previous_value}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </React.Fragment>
                                                    ))}
                                            </div>
                                        </div>}
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment >
    )
}

export const AddPackonShelfNotes = ({ setShowModal, showModal, patientProfileData, pageNumber, formData }) => {

    const [notes, setNotes] = useState([""]); // Initial state with one empty note

    const dispatch = useDispatch()
    const { AddBlisterPackResponse } = useBlisterSelectors()

    // Function to add a new note
    const handleAddNote = () => {
        if (notes.length < 5) {
            setNotes([...notes, ""]);
        }
    };

    // Function to delete a note at a specific index
    const handleDeleteNote = (index, noteId) => {
        if (window.confirm('Are you sure you want to delete this note?')) {
            setNotes(notes.filter((_, i) => i !== index));
            dispatch(handleDeleteBlisterPackNote({
                type: 'delete_blister_pack_note',
                formData, pageNumber, id: noteId
            }))
        }
    };

    // Function to update the value of a note
    // const handleChangeNote = (index, value) => {
    //     const updatedNotes = [...notes];
    //     updatedNotes[index] = value;
    //     setNotes(updatedNotes);
    // };

    // ... existing code ...

    // Function to update the value of a note
    const handleChangeNote = (index, value, noteId) => {
        const updatedNotes = [...notes];

        // If we have a noteId, maintain the object structure
        if (noteId) {
            updatedNotes[index] = {
                id: noteId,
                note: value
            };
        } else {
            // For new notes, create object with just note property
            updatedNotes[index] = {
                note: value
            };
        }

        setNotes(updatedNotes);
    };

    // ... existing code ...
    // const handleSaveNotes = () => {
    //     const { id, patient_id } = patientProfileData

    //     // Check if notes array has at least one non-empty value
    //     const hasValidNotes = notes?.some(note => note.trim() !== "");

    //     // const requestData = {
    //     //     pack_id: id,
    //     //     patient_id: patient_id,
    //     //     note: notes
    //     // }

    //     const requestData = {
    //         pack_id: id,
    //         patient_id: patient_id,
    //         note: notes
    //     }

    //     if (!hasValidNotes) {
    //         showToast("Please enter at least one note before saving.", 'error');
    //         return;
    //     }

    //     if (notes?.length > 0 && id && patient_id) {
    //         // dispatch(handleAddBlisterPackNote({
    //         //     type: 'add_blister_pack_note',
    //         //     requestData: requestData,
    //         //     setShowModal,
    //         //     formData, pageNumber
    //         // }))
    //         console.log(requestData)
    //     }
    // }

    // ... existing code ...

    const handleSaveNotes = () => {
        const { id, patient_id } = patientProfileData

        // Check if notes array has at least one non-empty value
        const hasValidNotes = notes?.some(note => note.note !== "");

        // Create array of note objects
        const formattedNotes = notes?.map(noteText => {
            const noteObj = {
                note: noteText.note
            };
            // Only add id if it exists in the note data
            if (noteText.id) {
                noteObj.id = noteText.id;
            }
            return noteObj;
        });

        const requestData = {
            pack_id: id,
            // patient_id: patient_id,
            all_notes: formattedNotes.filter(note => note.note !== "") // Remove empty notes
        }

        if (!hasValidNotes) {
            showToast("Please enter at least one note before saving.", 'error');
            return;
        }

        if (notes?.length > 0 && id && patient_id) {
            dispatch(handleAddBlisterPackNote({
                type: 'add_blister_pack_note',
                requestData: requestData,
                setShowModal,
                formData, pageNumber
            }))
        }
    }

    // ... existing code ...
    useEffect(() => {
        if (patientProfileData?.blisterpackNotes?.length > 0) {
            // Map the notes array to extract id and note fields
            const formattedNotes = patientProfileData?.blisterpackNotes?.map(noteItem => ({
                id: noteItem.id,
                note: noteItem.note
            }));
            setNotes(formattedNotes);
        } else {
            setNotes([{
                id: null,
                note: ""
            }])
        }
    }, [patientProfileData]);

    return (
        <React.Fragment>
            <div className="fixed top-0 left-0 right-0 z-50 bottom-0 flex items-center justify-center p-6 overflow-x-hidden overflow-y-auto bg-black bg-opacity-50 dark:bg-opacity-100">
                <div className="relative p-4 w-full max-w-2xl max-h-full" >
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                {patientProfileData?.name} {patientProfileData?.gender === 'male' ? '(M)' : '(F)'}
                            </h3>
                            <button type="button" onClick={() => handleHideModal(setShowModal, showModal, 'addPackOnShelfNotes')}
                                className="text-gray-400 close_btn hover:bg-gray-200 hover:text-gray-900 rounded-full 
								text-sm w-6 h-6 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                                <ModalCloseIcon />
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>

                        <div className="p-4 md:p-5 space-y-4">

                            {notes?.map((note, index) => (
                                <div key={index} className="flex flex-col  space-y-2">
                                    {/* <textarea
                                        value={note.note}
                                        onChange={(e) => handleChangeNote(index, e.target.value, note.id)}
                                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-0 focus:ring-transparent"
                                        placeholder={`Note ${index + 1}`}
                                    /> */}

                                    {/* // Update the textarea to handle both new and existing notes */}
                                    <textarea
                                        value={typeof note === 'object' ? note.note : note}
                                        onChange={(e) => handleChangeNote(index, e.target.value, note.id)}
                                        className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-0 focus:ring-transparent"
                                        placeholder={`Note ${index + 1}`}
                                    />
                                    <div className='flex gap-2'>
                                        {index > 0 && (<>
                                            <button
                                                onClick={() => handleDeleteNote(index, note.id)}
                                                className="px-2 py-1 bg-red-700 text-white text-xs rounded"
                                            >
                                                Delete
                                            </button>
                                        </>
                                        )}
                                        {index === notes.length - 1 && notes.length < 5 && (
                                            <button onClick={handleAddNote}
                                                className="w-fit bg-green-700 text-white px-2 py-1 rounded text-xs">
                                                Add Note
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}

                            <hr />

                            <div className='flex gap-2'>
                                <button
                                    onClick={handleSaveNotes}
                                    className="w-full bg-blue-700 text-white px-2 py-1 rounded  flex justify-center items-center">
                                    {AddBlisterPackResponse?.loading && AddBlisterPackResponse?.type === 'add_blister_pack_note' ? <ProfilePicLoader color='white' /> : 'Save'}
                                </button>

                                <button onClick={() => handleHideModal(setShowModal, showModal, 'addPackOnShelfNotes')}
                                    className="w-full bg-white border border-gray-300 text-gray-500 px-2 py-1 rounded ">
                                    Canel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment >
    )
}
